<footer
    class="relative"
    [ngClass]="{
        'bg-white': !template?.darkMode,
        'bg-gray-950': template?.darkMode,
        'text-white': template?.darkMode,
        'text-black': !template?.darkMode,
    }"
    [ngStyle]="{
        'background-color': template?.headerBackground,
    }">
    <app-component-overlay
        [component]="component"
        *ngIf="editMode"
        [isFooter]="true"
        [editMode]="editMode"></app-component-overlay>
    <div class="container mx-auto">
        <div class="w-full flex pt-8 px-4 gap-4 h-auto" *ngIf="template?.footer?.showFullFooter">
            <div class="md:min-h-[200px] w-full md:w-1/2">
                <advanced-image
                    class="mb-4 w-[100px]"
                    *ngIf="template?.footer?.showLogo !== false"
                    [cldImg]="logoImg"
                    [alt]="client?.name">
                </advanced-image>
                <ul
                    role="list"
                    class="mt-6 pl-0 space-y-2 list-none list-outside"
                    [ngClass]="template?.footer?.menuLinkSize || 'text-sm'"
                    *ngIf="template?.footer?.showMenu !== false">
                    <li *ngIf="client?.website">
                        <a
                            [href]="client?.website"
                            target="_blank"
                            aria-label="Visit our homepage"
                            [title]="(client?.displayName || client?.name) + ' homepage'"
                            rel="noopener"
                            class="font-bold"
                            i18n
                            >{{ (client?.displayName || client?.name) }} homepage</a
                    >
                    </li>
                    <li *ngFor="let page of menuConfig?.top" class="font-bold">
                        <a *ngIf="page.slug" [title]="page.title" [routerLink]="['/', page.slug]" rel="noopener">{{
                            page.title
                        }}</a>
                        <a *ngIf="page.link" [title]="page.title" [routerLink]="['/', page.slug]" target="_blank" rel="noopener">{{
                            page.title
                        }}</a>
                    </li>
                    <li *ngFor="let menuHeading of menuConfig?.menuHeadings | keyvalue">
                        <h4 class="text-sm font-semibold">{{ menuHeading?.value?.title }}</h4>
                        <a
                            [title]="page.title"
                            *ngFor="let page of menuHeading?.value?.links"
                            [routerLink]="['/', page.slug]"
                            class="font-bold"
                            >{{ page.title }}</a
                        >
                    </li>
                </ul>
            </div>
            <div class="md:min-h-[200px] w-0 md:w-1/2"></div>
        </div>
        <div class="w-full flex flex-col md:flex-row pb-8 px-4 mt-4 gap-4" *ngIf="template?.footer?.showFullFooter">
            <div class="w-full md:w-1/2">
                <p class="text-xs" i18n>&copy; {{ client?.displayName || client?.name }}. All rights reserved.</p>
            </div>
            <div
                class="w-full md:w-1/2 flex gap-2 text-right md:justify-end"
                *ngIf="template?.footer?.showSocialLinks !== false">
                <span *ngIf="socialLinks.facebook">
                    <a
                        [title]="(client?.displayName || client?.name) + ' Facebook'"
                        [href]="socialLinks.facebook"
                        target="_blank"
                        rel="noopener"
                        aria-label="Facebook">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.twitter">
                    <a
                        [title]="(client?.displayName || client?.name) + ' X'"
                        [href]="socialLinks.twitter"
                        target="_blank"
                        rel="noopener"
                        aria-label="X">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.linkedin">
                    <a
                        [title]="(client?.displayName || client?.name) + ' LinkedIn'"
                        [href]="socialLinks.linkedin"
                        target="_blank"
                        rel="noopener"
                        aria-label="LinkedIn">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.youtube">
                    <a
                        [title]="(client?.displayName || client?.name) + ' YouTube'"
                        [href]="socialLinks.youtube"
                        target="_blank"
                        rel="noopener"
                        aria-label="YouTube">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.instagram">
                    <a
                        [title]="(client?.displayName || client?.name) + ' Instagram'"
                        [href]="socialLinks.instagram"
                        target="_blank"
                        rel="noopener"
                        aria-label="Instagram">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.glassdoor">
                    <a
                        [title]="(client?.displayName || client?.name) + ' Glassdoor'"
                        [href]="socialLinks.glassdoor"
                        target="_blank"
                        rel="noopener"
                        aria-label="Glassdoor">
                        <svg class="h-4 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <g id="surface1">
                                <path
                                    d="M 17.144531 20.570312 L 3.429688 20.570312 C 3.429688 22.464844 4.964844 24 6.855469 24 L 17.140625 24 C 19.035156 24 20.570312 22.464844 20.570312 20.570312 L 20.570312 6.492188 C 20.570312 6.421875 20.515625 6.367188 20.445312 6.367188 L 17.265625 6.367188 C 17.199219 6.367188 17.144531 6.421875 17.144531 6.492188 L 17.144531 20.574219 Z M 17.144531 0 C 19.035156 0 20.570312 1.535156 20.570312 3.429688 L 6.859375 3.429688 L 6.859375 17.507812 C 6.859375 17.574219 6.800781 17.632812 6.734375 17.632812 L 3.554688 17.632812 C 3.484375 17.632812 3.429688 17.574219 3.429688 17.507812 L 3.429688 3.429688 C 3.429688 1.535156 4.964844 0 6.855469 0 Z M 17.144531 0 " />
                            </g>
                        </svg>
                    </a>
                </span>
                <span *ngIf="socialLinks.tiktok">
                    <a
                        [title]="(client?.displayName || client?.name) + ' TikTok'"
                        [href]="socialLinks.tiktok"
                        target="_blank"
                        rel="noopener"
                        aria-label="TikTok">
                        <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z" />
                        </svg>
                    </a>
                </span>
            </div>
        </div>
        <div class="w-full my-2 px-4 justify-center text-xs flex gap-2 py-4">
            <span>Powered by <a href="http://www.voyse.co.uk" i18n>Voyse</a> &copy; 2025</span>
            <a
                title="Voyse - Privacy Policy"
                class="hover:text-indigo-600"
                rel="noopener"
                rel="nofollow"
                target="_blank"
                href="http://www.voyse.co.uk/privacy"
                i18n
                >Privacy</a
            >
            <a
                title="Voyse - Terms & Conditions"
                class="hover:text-indigo-600"
                rel="noopener"
                rel="nofollow"
                target="_blank"
                href="http://www.voyse.co.uk/terms"
                i18n
                >Terms</a
            >
        </div>
    </div>
</footer>
